module.exports = __webpack_public_path__ + "img/322-e8eb3e.png";